module.exports = __webpack_public_path__ + "static/img/liucheng.954e66dc.png";